/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Trigger_Intro_DatasetInputs */



/**
* | output |
* | --- |
* | "Runs this agent each time the dataset reports an event under this name — something its tables are set up to announce, such as a new order over 1,000. Ask in ..." |
*
* @param {Agent_Event_Trigger_Intro_DatasetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_intro_dataset = /** @type {((inputs?: Agent_Event_Trigger_Intro_DatasetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_Intro_DatasetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Startet diesen Agenten jedes Mal, wenn der Datensatz ein Ereignis unter diesem Namen meldet – etwas, das seine Tabellen melden sollen, etwa eine neue Bestellung über 1.000. Bitten Sie in einem Chat darum, das einzurichten. Der Agent sieht, was das Ereignis mitbringt. So gestartete Läufe fragen immer, bevor sie etwas ändern.")
	return /** @type {LocalizedString} */ ("Runs this agent each time the dataset reports an event under this name — something its tables are set up to announce, such as a new order over 1,000. Ask in a chat to set that up. The agent sees what the event carried. Runs started this way always ask before changing anything.")
});